import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ThemeProvider } from "./components/ThemeProvider";
import Home from "./pages/Home";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { CookieBanner } from "./components/CookieBanner";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { initAnalytics } from "./lib/analytics";

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <ThemeProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </BrowserRouter>
            <WhatsAppButton />
            <CookieBanner />
            <Toaster position="top-right" theme="dark" richColors />
          </ThemeProvider>
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
